import { Award, CheckCircle, Clock, Shield, Star, Users } from "lucide-react";

export const services = [
  {
    id: 1,
    title: "Project Execution and Innovation",
    description:
      "We deliver efficient and results-oriented project execution through effective planning, coordination, and management. Our team integrates innovative methods, modern tools, and sustainable practices to ensure every project achieves its objectives on time and within budget.",
    image: "/images/innovation.jpg", // Replace with your actual image path
    // "https://i.pinimg.com/736x/b9/b6/0e/b9b60eb215193ce939ca6721601a846b.jpg", // Replace with your actual image path
  },
  {
    id: 2,
    title: "Tender Participation and Project Implementation",
    description:
      "We actively participate in competitive tenders with a strong commitment to transparency, compliance, and value for money. Upon award, we ensure seamless implementation through structured planning, resource management, and quality assurance.",
    image: "/images/projectImplementation.jpg", // Replace with your actual image path
  },
  {
    id: 3,
    title: "Consultancy and Non-Consultancy Services",
    description:
      "Our consultancy services cover a broad range of sectors, including engineering, transport, garment production, business development, and project management. We also offer non-consultancy support such as training, supervision, and field coordination to strengthen institutional capacity and improve project outcomes.",
    image: "/images/Consultancy.jpg", // Replace with your actual image path
  },
  {
    id: 4,
    title: "Civil Engineering and Construction Works",
    description:
      "We provide complete civil engineering and construction services, from design and supervision to project completion. Our expertise covers buildings, roads, drainage systems, and general infrastructure — ensuring safety, quality, and long-term durability.",
    image: "/images/construction.jpg", // Replace with your actual image path
  },
];

export const our_customers = [
  {
    image:
      "https://i.pinimg.com/736x/17/c1/d9/17c1d903910937ecfd18943ee06279c2.jpg",
    // "/logo-fav.jpg",
    name: "Amina K.",
  },
  {
    image:
      // "https://i.pinimg.com/1200x/d7/4c/10/d74c1008b4642a03137ef315087a9dab.jpg",
      "/logo-fav.jpg",
    name: "Jack M.",
  },
  {
    image:
      "https://i.pinimg.com/736x/fb/23/63/fb2363972fe0487685467f288cad0f6c.jpg",
    // "/logo-fav.jpg",
    name: "Elena V.",
  },
  {
    image:
      // "https://i.pinimg.com/1200x/7d/9a/68/7d9a68865d3f1688c2a7eec2b7bdf8da.jpg",
      "/logo-fav.jpg",
    name: "Samuel T.",
  },
];

export const testimonials = [
  {
    quote:
      "Hexad transformed our digital infrastructure, resulting in 40% cost savings.",
    name: "Sarah Chen",
    role: "CTO, TechInnovate",
    image: "/logo-fav.jpg",
    // "https://images.unsplash.com/photo-1607746882042-944635dfe10e?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
  },
  {
    quote:
      "Working with Hexad streamlined our workflows and boosted productivity across all departments.",
    name: "David Okoro",
    role: "Operations Manager, GlobalReach",
    image: "/logo-fav.jpg",
    // "https://i.pinimg.com/736x/17/c1/d9/17c1d903910937ecfd18943ee06279c2.jpg",
  },
  {
    quote:
      "Their engineering team delivered scalable solutions that supported our rapid growth.",
    name: "Elena Petrova",
    role: "Head of Engineering, BuildSmart",
    image: "/logo-fav.jpg",
    // "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
  },
  {
    quote:
      "Hexad’s consulting expertise helped us modernize legacy systems without disrupting operations.",
    name: "Michael Johnson",
    role: "CIO, FinEdge",
    image: "/logo-fav.jpg",
    // "https://i.pinimg.com/736x/17/c1/d9/17c1d903910937ecfd18943ee06279c2.jpg",
  },
  {
    quote:
      "The project management support ensured our construction projects were delivered on time and on budget.",
    name: "Amina Yusuf",
    role: "Project Director, ConstructPro",
    image: "/logo-fav.jpg",
    // "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
  },
];

export const teamMembers = [
  {
    name: "Usanase Denis",
    role: "Chief Executive Officer",
    bio: "Provides strategic leadership and vision for Hexad, driving innovation, partnerships, and sustainable growth across technology, engineering, and business transformation services.",
    email: "denis.usanase@hexad.co.rw",
    image: "/team/denis_one.jpg",
    socials: {
      linkedin: "#",
      twitter: "#",
    },
  },
  {
    name: "Ndizera Claude",
    role: "Executive Director",
    bio: "Oversees operations and client engagement at Hexad, ensuring delivery excellence and fostering long-term relationships with industry partners and stakeholders.",
    email: "claude.ndizera@hexad.co.rw",
    image: "/team/claude.jpg",
    socials: {
      linkedin: "#",
    },
  },
  {
    name: "Uzabumwana Liliane",
    role: "Administrative Assistant",
    bio: "Supports Hexad’s executive team with administrative coordination, communication management, and organizational efficiency to keep projects and operations running smoothly.",
    email: "liliane.uzabumwana@hexad.co.rw",
    image: "/team/liliane.jpg",
    socials: {
      linkedin: "#",
    },
  },
  // Below for the team
  {
    name: "Janviere Nyirabagirishya",
    role: "Head of Corporate Services",
    bio: "Oversees corporate strategy execution, administrative excellence, and service delivery optimization at Hexad. Ensures alignment between operational functions and business objectives while fostering a productive work environment.",
    email: "janviere.nyirabagirishya@hexad.co.rw",
    // image: "/team/immaculate.jpg",
    image: "/logo-fav.jpg",
    socials: {
      linkedin: "#",
    },
  },
  {
    name: "Chrispine Musanabera",
    role: "Chief Accountant",
    bio: "Directs financial planning, accounting operations, and fiscal management at Hexad. Implements robust financial controls, monitors performance metrics, and provides strategic insights for informed decision-making and sustainable financial health.",
    email: "chrispine.musanabera@hexad.co.rw",
    image: "/team/chrispine.jpg",
    socials: {
      linkedin: "#",
    },
  },
  {
    name: "Gregoire Nsengiyunva",
    role: "Compliance and Administration Officer",
    bio: "Champions regulatory compliance, risk management, and administrative protocols at Hexad. Develops and implements policies that ensure operational integrity while supporting efficient organizational processes and governance standards.",
    email: "gregoire.nsengiyumva@hexad.co.rw",
    image: "/team/gregoire.jpg",
    socials: {
      linkedin: "#",
    },
  },
  {
    name: "Dusabe François",
    role: "Bids and Commercial Officer",
    bio: "Coordinates proposal development, commercial documentation, and bid submission processes at Hexad. Supports competitive positioning and client engagement through meticulous preparation of tender responses and commercial materials.",
    email: "francois.dusabe@hexad.co.rw",
    image: "/team/dusabe.jpg",
    socials: {
      linkedin: "#",
    },
  },
  {
    name: "J.Happy Manyenzi",
    role: "Digital & IT Officer",
    bio: "Leads technology infrastructure management, digital systems maintenance, and IT support services at Hexad. Implements technological solutions that enhance operational efficiency and support the company's digital transformation journey.",
    email: "jhappy.manyenzi@hexad.co.rw",
    image: "/team/happy.jpg",
    socials: {
      linkedin: "#",
    },
  },
  {
    name: "Theogene Hitimana",
    role: "Driver",
    bio: "Ensures reliable transportation services and logistical support for Hexad's operations. Maintains vehicle safety standards and provides efficient mobility solutions that support the team's field activities and resource distribution.",
    email: "theodette.ninshuti@hexad.co.rw",
    image: "/team/hitimana.jpg",
    socials: {
      linkedin: "#",
    },
  },
  //
  {
    name: "Patrick Nshimiyimana",
    role: "Tenders and Contracts Coordinator",
    bio: "Coordinates procurement processes and contract management to ensure compliance and value for Hexad Ltd. Oversees tender documentation, supplier engagement, and contract execution to support operational efficiency and strategic sourcing.",
    email: "patrick.nshimiyimana@hexad.co.rw",
    image: "/logo-fav.jpg",
    socials: {
      linkedin: "#",
    },
  },
  {
    name: "Gatete Prosper",
    role: "Business Development Manager",
    bio: "Drives strategic partnerships and market expansion initiatives for Hexad Ltd. Identifies growth opportunities, nurtures client relationships, and develops tailored solutions that align with the company’s vision and operational goals.",
    email: "gatete.prosper@hexad.co.rw",
    image: "/team/gatete.png",
    socials: {
      linkedin: "#",
    },
  },
];

export const caseStudies = [
  {
    title: "Healthcare System Upgrade",
    result: "99.9% Uptime",
    duration: "8 Months",
    category: "Technology",
  },
  {
    title: "Supply Chain Optimization",
    result: "40% Faster",
    duration: "6 Months",
    category: "Logistics",
  },
  {
    title: "AI Implementation",
    result: "75% Automation",
    duration: "12 Months",
    category: "Innovation",
  },
];

export const projects = [
  {
    title: "Smart Irrigation System",
    category: "Agribusiness",
    img: "/images/irigation.jpg",
    // img: "https://i.pinimg.com/1200x/25/30/04/25300440c5b32795f496a5f1e9425f7d.jpg",
    desc: "A fully automated irrigation solution enhancing water efficiency for farmers.",
    duration: "6 Months",
    team: "8 Members",
  },
  {
    title: "Road Construction Project",
    category: "Construction",
    img: "/images/road.jpg",
    // img: "https://i.pinimg.com/1200x/25/30/04/25300440c5b32795f496a5f1e9425f7d.jpg",
    desc: "High-quality road development improving transportation and community access.",
    duration: "12 Months",
    team: "15 Members",
  },
  {
    title: "Digital Transformation Portal",
    category: "Technology",
    img: "/images/digital.jpg",
    // img: "https://i.pinimg.com/1200x/25/30/04/25300440c5b32795f496a5f1e9425f7d.jpg",
    desc: "A modern digital platform helping businesses automate operations.",
    duration: "4 Months",
    team: "6 Members",
  },
  {
    title: "Garment Production Line",
    category: "Manufacturing",
    img: "/images/garmet.jpg",
    // img: "https://i.pinimg.com/1200x/25/30/04/25300440c5b32795f496a5f1e9425f7d.jpg",
    desc: "Mass production of industrial uniforms and quality textile products.",
    duration: "8 Months",
    team: "12 Members",
  },
  {
    title: "Renewable Energy Installation",
    category: "Engineering",
    img: "/images/renew.jpg",
    // img: "https://i.pinimg.com/736x/68/5e/8a/685e8ab1c0eab0735a4c1bc951116e66.jpg",
    desc: "Solar power systems implementation for sustainable energy solutions.",
    duration: "5 Months",
    team: "10 Members",
  },
  {
    title: "Urban Transport System",
    category: "Transport",
    img: "/images/urban.jpg",
    // img: "https://i.pinimg.com/736x/35/47/48/354748471cbad482eccf036d1db1a86c.jpg",
    desc: "Modern transportation infrastructure development for urban mobility.",
    duration: "18 Months",
    team: "20 Members",
  },
];

export const whyChooseUs = [
  {
    icon: <Shield className="w-5 h-5" />,
    title: "Integrity & Accountability",
    desc: "Honest, transparent operations aligned to standards.",
  },
  {
    icon: <Award className="w-5 h-5" />,
    title: "Proven Expertise",
    desc: "Skilled teams with strong technical know-how.",
  },
  {
    icon: <Users className="w-5 h-5" />,
    title: "Innovation & Efficiency",
    desc: "Modern solutions guided by smart technology.",
  },
  {
    icon: <Clock className="w-5 h-5" />,
    title: "Timely Delivery",
    desc: "Projects completed on schedule and within budget.",
  },
  {
    icon: <Star className="w-5 h-5" />,
    title: "Quality Assurance",
    desc: "Strict quality control for durable outcomes.",
  },
  {
    icon: <CheckCircle className="w-5 h-5" />,
    title: "Comprehensive Services",
    desc: "End-to-end support from planning to execution.",
  },
];

export const fullProject = {
  title: "Smart Irrigation System",
  category: "Agribusiness",
  img: "https://i.pinimg.com/1200x/25/30/04/25300440c5b32795f496a5f1e9425f7d.jpg",
  desc: "A fully automated irrigation solution designed to optimize water usage, monitor soil conditions, and support farmers with real-time decision insights.",
  duration: "6 Months",
  team: "8 Members",
  slug: "smart-irrigation-system", // for detail page routing

  // NEW extended fields:
  overview:
    "The Smart Irrigation System project focuses on increasing water efficiency and crop productivity by integrating IoT-enabled sensors, automated valve control, and data-driven decision support. Designed for small-to-medium-scale farmers, the system reduces water waste by up to 40% and provides real-time insights through a mobile dashboard.",

  objectives: [
    "Reduce water consumption using automated irrigation cycles.",
    "Monitor soil moisture, humidity, and temperature in real time.",
    "Provide farmers with actionable data through an intuitive dashboard.",
    "Ensure the system works in remote areas with low internet connectivity.",
  ],

  technologies: [
    "IoT Sensors (Soil Moisture, DHT11, Water Flow)",
    "Solar-Powered Microcontroller Unit (ESP32)",
    "LoRaWAN Gateway for Long-Range Communication",
    "Node.js & Express Backend",
    "React Dashboard Interface",
    "Firebase Cloud Messaging (Real-time alerts)",
  ],

  features: [
    "AI-driven irrigation scheduling",
    "Mobile alerts for moisture thresholds",
    "Remote valve control",
    "Water consumption analytics",
    "Offline fallback mode",
  ],

  results: [
    "40% reduction in water usage in pilot farms",
    "20–30% increase in crop yield due to optimized irrigation",
    "50+ farmers onboarded in the first deployment cycle",
    "Reduced manual labor hours by 60%",
  ],

  gallery: [
    "https://i.pinimg.com/1200x/33/b2/23/33b22380b6f1d1492f22b2dc2d47cc96.jpg",
    "https://i.pinimg.com/1200x/33/b2/23/33b22380b6f1d1492f22b2dc2d47cc96.jpg",
    "https://i.pinimg.com/1200x/33/b2/23/33b22380b6f1d1492f22b2dc2d47cc96.jpg",
  ],

  client: "GreenHarvest Cooperative – Northern Agricultural Zone",
  location: "Garu-Tempane District, Ghana",
  completionDate: "2024",
};

export const fullServices = {
  id: 1,
  title: "Technology Solutions",
  description:
    "Custom software development, digital transformation, and scalable IT infrastructure tailored to modern business needs.",
  image:
    "https://i.pinimg.com/736x/b9/b6/0e/b9b60eb215193ce939ca6721601a846b.jpg",

  // --- DETAIL PAGE CONTENT ---
  longDescription:
    "Our Technology Solutions service empowers organizations to modernize operations, enhance efficiency, and embrace innovation. From enterprise-grade software platforms to cloud-native infrastructure and automation workflows, we deliver end-to-end solutions built for long-term scalability and performance.",

  objectives: [
    "Modernize legacy systems and processes.",
    "Build scalable, secure, and cloud-ready infrastructure.",
    "Enhance customer experience through digital transformation.",
    "Increase operational efficiency using automation technologies.",
  ],

  features: [
    "Custom Web & Mobile Development",
    "Cloud Migration & Infrastructure Setup",
    "API Development & Integrations",
    "Automation & Workflow Optimization",
    "Cybersecurity & System Hardening",
    "IT Consulting & Managed Support",
  ],

  benefits: [
    "Reduced operational costs",
    "Improved efficiency and response time",
    "Increased data security and reliability",
    "Future-ready digital ecosystems",
  ],

  technologies: [
    "React",
    "Node.js",
    "AWS",
    "Docker",
    "PostgreSQL",
    "Kubernetes",
    "Python",
  ],

  industriesServed: [
    "Finance",
    "Healthcare",
    "Retail",
    "Agriculture",
    "Public Sector",
  ],

  gallery: [
    "https://i.pinimg.com/1200x/7c/51/ad/7c51adfbc4abc24424318a5c37de4336.jpg",
    "https://i.pinimg.com/1200x/7c/51/ad/7c51adfbc4abc24424318a5c37de4336.jpg",
    "https://i.pinimg.com/1200x/7c/51/ad/7c51adfbc4abc24424318a5c37de4336.jpg",
  ],
};
